const state = {
    typeDocumentStarassignment:[],
    typeCategoryStarAssignment:{},
    typeStar:[],
    cardsList: [],
    loading: false,
    template:[],
    templateDownload:null,
    postTemplate:null,
    listTypeStar:[],
    listZenStarRequests:[],
    listStarZenStatus:[],
    loadingZen: false,
    jobStatus: null

};

export default state;